__turbopack_context__.v({
  "checkbox": "ModalError-module-scss-module__URU4yW__checkbox",
  "checkbox__input": "ModalError-module-scss-module__URU4yW__checkbox__input",
  "formWrapper": "ModalError-module-scss-module__URU4yW__formWrapper",
  "modalErrorBack": "ModalError-module-scss-module__URU4yW__modalErrorBack",
  "modalErrorBox": "ModalError-module-scss-module__URU4yW__modalErrorBox",
  "modalErrorBtn": "ModalError-module-scss-module__URU4yW__modalErrorBtn",
  "modalErrorBtnClose": "ModalError-module-scss-module__URU4yW__modalErrorBtnClose",
  "modalErrorContainer": "ModalError-module-scss-module__URU4yW__modalErrorContainer",
  "modalErrorText": "ModalError-module-scss-module__URU4yW__modalErrorText",
  "modalErrorTitle": "ModalError-module-scss-module__URU4yW__modalErrorTitle",
  "modalText": "ModalError-module-scss-module__URU4yW__modalText",
});
